export default __webpack_public_path__ + "static/media/Nitro-doc.a8bb5c17.png";